import { render, staticRenderFns } from "./SupplimentaryCard.vue?vue&type=template&id=ebb1fb38&scoped=true&"
import script from "./SupplimentaryCard.vue?vue&type=script&lang=js&"
export * from "./SupplimentaryCard.vue?vue&type=script&lang=js&"
import style0 from "./SupplimentaryCard.vue?vue&type=style&index=0&id=ebb1fb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb1fb38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
